/**
 * Contact form labels
 *
 * The contact form labels behave like placeholders when the input is not
 * focused and does not have a value and like labels when the input does have
 * focus or a value.
 */
$(function() {
    var inputs = $('.contact-form .text-input');

    if (inputs.length === 0) {
        return;
    }

    inputs.each(function(i, element) {
        var input = $(element);
        var field = input.parent('.field');

        // On focus, add the focus class (which makes the label text blue) and
        // remove the placeholder class (which places the label over the top of
        // the input).
        input.on('focus', function() {
            field.addClass('focused');
            field.removeClass('placeholder');
        });

        // On blur, remove the focus class and restore the placeholder class,
        // but only if the input is empty.
        input.on('blur', function() {
            field.removeClass('focused');

            if (input.val() === '') {
                field.addClass('placeholder');
            }
        });

        // On load, add the placeholder class to empty inputs.
        if (input.val() === '') {
            field.addClass('placeholder');
        }
    });
});
